module.exports = __webpack_public_path__ + "static/media/main-ci.63d0ec1b.png";